const styles = (theme) => ({
    submitButton: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        position: 'relative',
        padding: theme.spacing(1, 0),
    },
    submitProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

export default styles;
